module.exports = __webpack_public_path__ + "static/logo.9769190d.svg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/AlgoliaSearch/logo.svg
// module id = 1047
// module chunks = 0 1 2 3 4 5 6 7 8